import { createFeature, createSelector } from '@ngrx/store';

import { isolateFilename } from 'shared-utils/file';

import { dpuFileReducer } from './dpu-file.reducer';

export const dpuFileFeature = createFeature({
  name: 'dpuFile',
  reducer: dpuFileReducer,
  extraSelectors: ({ selectCurrentDataOrSetupFilePath, selectFileType }) => ({
    selectDpuFileType: createSelector(
      selectFileType,
      fileType => fileType,
    ),
    selectDpuFileNameWithoutExtension: createSelector(
      selectCurrentDataOrSetupFilePath,
      path => path ? isolateFilename(path) : undefined,
    ),
  }),
});
